export const WECHAT_APPID = 'wxca069443762320ec'



//export const WECHAT_APPID = 'wxca069443762320ec'

/** 授权回调地址，去掉 code/state 避免重复授权 */
export function getOAuthRedirectUrl(href) {
  const url = new URL(href || window.location.href)
  url.searchParams.delete('code')
  url.searchParams.delete('state')
  return url.href
}

export const WECHAT_OAUTH_ERROR_MSG = '请登录[橙链plus]小程序查看职位详情'

export function isWechatBrowser() {
  return /MicroMessenger/i.test(navigator.userAgent)
}

export function showWechatOAuthError() {
  alert(WECHAT_OAUTH_ERROR_MSG)
}

/**
 * 微信网页授权（静默 snsapi_base，仅需 openid，订阅号/未认证号可用）
 * snsapi_userinfo 需认证服务号，否则会报 10005
 * @returns {boolean} 是否已发起授权跳转
 */
export function redirectToWechatOAuth(href) {
  try {
    showWechatOAuthError();
    return false
    /**if (!isWechatBrowser()) {
      showWechatOAuthError()
      return false
    }
    if (!WECHAT_APPID) {
      showWechatOAuthError()
      return false
    }
    const redirectUri = encodeURIComponent(getOAuthRedirectUrl(href))
    window.location.href =
      `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WECHAT_APPID}` +
      `&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
    return true */
  } catch (e) {
    showWechatOAuthError()
    return false
  }
}


function getWhitelistedOrigin() {
  const uri = process.env.VUE_APP_OAUTH_REDIRECT_URI
  if (!uri) return null
  try {
    return new URL(uri).origin
  } catch (e) {
    return null
  }
}

/** 授权回调地址：使用公众号配置的域名，保留当前路径，去掉 code/state */
/** export function getOAuthRedirectUrl(href) {
  const current = new URL(href || window.location.href)
  current.searchParams.delete('code')
  current.searchParams.delete('state')

  const whitelistedOrigin = getWhitelistedOrigin()
  if (whitelistedOrigin) {
    const base = new URL(whitelistedOrigin)
    current.protocol = base.protocol
    current.host = base.host
  }
  return current.href
} */

/**
 * 微信网页授权（snsapi_base）
 * redirect_uri 必须是公众号后台「网页授权域名」下的地址，不能用 localhost / 内网 IP
 */
/** 
 * export function redirectToWechatOAuth(href) {
  const redirectUri = encodeURIComponent(getOAuthRedirectUrl(href))
  window.location.href =
    `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${WECHAT_APPID}` +
    `&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect`
} */

export function getUrlCode(href) {
  const url = href || window.location.href
  const match = url.match(/[?&]code=([^&#]+)/)
  return match ? decodeURIComponent(match[1]) : ''
}

/** 授权回调后清理地址栏中的 code，避免重复使用导致登录失败 */
export function cleanOAuthQueryFromUrl() {
  const url = new URL(window.location.href)
  if (!url.searchParams.has('code')) return
  url.searchParams.delete('code')
  url.searchParams.delete('state')
  window.history.replaceState(null, '', url.pathname + url.search + url.hash)
}

/**
 * 用授权 code 换取用户信息
 * redirectUri 须与发起授权时一致，否则后端向微信换 token 会失败
 */
export function exchangeWechatCode(http, code) {
  const redirectUri = getOAuthRedirectUrl()
  return http.getUserInfo({ code, redirectUri, redirect_uri: redirectUri })
}
